import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { SmoothScroll } from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import Clients from "@/pages/Clients";
import People from "@/pages/People";
import Stories from "@/pages/Stories";
import Story from "@/pages/Story";
import Work from "@/pages/Work";
import RedBull from "@/pages/RedBull";
import Kotak from "@/pages/Kotak";
import Idfc from "@/pages/Idfc";
import At20 from "@/pages/At20";
import ComingSoon from "@/pages/ComingSoon";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const tryScroll = (attempt = 0) => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (attempt < 10) {
          setTimeout(() => tryScroll(attempt + 1), 60);
        }
      };
      tryScroll();
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App grain min-h-screen bg-[#0a0a0a]">
      <BrowserRouter>
        <ScrollManager />
        <SmoothScroll>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/people" element={<People />} />
            <Route path="/stories" element={<Stories />} />
            <Route path="/stories/:slug" element={<Story />} />
            <Route path="/work" element={<Work />} />
            <Route path="/work/red-bull" element={<RedBull />} />
            <Route path="/work/kotak" element={<Kotak />} />
            <Route path="/work/idfc" element={<Idfc />} />
            <Route path="/work/at20" element={<At20 />} />
            <Route path="/:gateway" element={<ComingSoon />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
